import { render } from "./ExchangeRatesForm.vue?vue&type=template&id=10a595d8&scoped=true"
import script from "./ExchangeRatesForm.vue?vue&type=script&lang=js"
export * from "./ExchangeRatesForm.vue?vue&type=script&lang=js"

import "./ExchangeRatesForm.vue?vue&type=style&index=0&id=10a595d8&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a595d8"]])

export default __exports__